import styled from "styled-components";

export const Container = styled.div`
  margin-top: 20px;

  h1 {
    margin-bottom: 20px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
